module.exports = __webpack_public_path__ + "img/cloud.52cdfe08.png";